import { getAuthToken } from './TokenService';

const GetFileHistory = {
  async GetHistory(path = '/') {
    try {
      const token = await getAuthToken();
      
      let url = `https://chat.int.bayer.com/api/v2/files?path=${encodeURIComponent(path)}&limit=200&offset=0&name=`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      let filesArray = Array.isArray(data) ? data : (data.files || data.data || []);
      
      return {
        filesArray
      };
    } catch (error) {
      console.error('Error fetching files history:', error);
      throw error;
    }
  }
};

export { GetFileHistory };